import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import {toast} from "react-toastify";
import ApiConnect from "../../Utils/ApiConnect";

function DeletePop(props) {
  const [btnDisbale, SetbtnDisable] = useState(false);
  const i = Math.random();
  const deleteAction = () => {
    SetbtnDisable(true);
    ApiConnect.delete(`${props.delUrl}`)
      .then((response) => {
        SetbtnDisable(false);
        if (response.data.status === 202) {
          props.fallAction();
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          props.hideTrigger(false);
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
        }
        props.hideTrigger(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  return (
    <Modal
      show={props.trigger}
      className="modal-center"
      onHide={() => props.hideTrigger(false)}
      key={i}
    >
      <Modal.Dialog>
        <Modal.Body>
          <div className="text-center">
            <div className="">
              <h2>Are you sure?</h2>
              <h6>You won't be able to revert this!</h6>
            </div>
            <button
              onClick={() => {
                deleteAction();
              }}
              className="btn btn-danger m-3"
              disabled={btnDisbale}
            >
              Yes, delete it!
            </button>
            <button
              className="btn btn-success m-e"
              onClick={() => props.hideTrigger(false)}
            >
              No, cancel!
            </button>
          </div>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
}
export default React.memo(DeletePop);
